


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import VideoPlayer from '@/components/common/VideoPlayer.vue';
import PortalIcon from '@/components/icons/PortalIcon.vue';

@Component({
  components: { VideoPlayer, PortalIcon },
})
export default class TeaserVideo extends Vue {
  @Prop(String) readonly cover!: string;

  @Prop(String) readonly source!: string;

  paused = true;

  @Watch('paused')
  pausedChanged(paused: boolean) {
    this.$emit('paused', paused);
  }

  handlePlayClick() {
    this.paused = false;
  }

  handlePaused(paused: boolean) {
    this.paused = paused;
  }
}
